const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`)

if (artikeldetail && window.XMLHttpRequest) {
    let heftId = artikeldetail.getAttribute("data-heft-issue")
    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    if (document.querySelector('[id^=iww-readerbar]') !== null && (fromParam !== null && ((heftId == fromParam) || fromParam.includes("nl_")))) {
        let readerbarElement = null
        let linkbarElement = null
        if (heftId == fromParam) {
            readerbarElement = document.getElementById('iww-readerbar')
            linkbarElement = document.getElementById('iww-linkbar')
        } else if (fromParam.includes("nl_")) {
            readerbarElement = document.getElementById('iww-readerbar-newsletter')
            linkbarElement = document.getElementById('iww-linkbar')
        }

        if (readerbarElement == null || linkbarElement == null) {
            return
        }

        const readerbar = linkbarElement.getBoundingClientRect().bottom + window.scrollY;

        // Einmal onload ausführen um progress auch schon vor dem ersten scrollen zu haben
        if (document.body.getBoundingClientRect().top < readerbar * -1) {
            readerbarElement.setAttribute('aria-hidden', 'true');
        } else {
            readerbarElement.setAttribute('aria-hidden', 'false');
        }

        window.addEventListener('scroll', function () {

            if (document.body.getBoundingClientRect().top < readerbar * -1) {
                readerbarElement.setAttribute('aria-hidden', 'true');
            } else {
                readerbarElement.setAttribute('aria-hidden', 'false');
            }
        });
    }
}
